exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] .cdsvrOYooW710gLYdYVxd{border-bottom:1px solid var(--neutralLight)}.cdsvrOYooW710gLYdYVxd ._2rt8AySlmZux2nYiJl6ej5{font-size:14px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}.cdsvrOYooW710gLYdYVxd .aRkCuXU2On51hO1NQAJLI{width:263px}html[dir] .cdsvrOYooW710gLYdYVxd .aRkCuXU2On51hO1NQAJLI{margin-top:15px;margin-bottom:24px}.BKuR-mAVsuMMU7hDFTOaR{display:block}html[dir=ltr] .BKuR-mAVsuMMU7hDFTOaR button{padding-left:11px}html[dir=rtl] .BKuR-mAVsuMMU7hDFTOaR button{padding-right:11px}", ""]);

// exports
exports.locals = {
	"shareACalendarWrapper": "cdsvrOYooW710gLYdYVxd",
	"shareACalendarSectionMessage": "_2rt8AySlmZux2nYiJl6ej5",
	"dropdownContainer": "aRkCuXU2On51hO1NQAJLI",
	"shareACalendarCallout": "BKuR-mAVsuMMU7hDFTOaR"
};